import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import { Grid } from "../Grid";
import { SubmissionsGridProps } from "./SubmissionsGridProps";
import { CreateStaticSelectColumnFilter } from "../../leap-components/Grid/FetchGrid/StaticSelectColumnFilter";
import {
  GetSubmissionsByLicenceFetchUrl,
  ISubmissionRow,
} from "../../api/ISubmission";

const SubmissionsGrid = ({
  licenceId,
  licenceProfile,
  submissionTypes,
  submissionObjectorTypes,
}: SubmissionsGridProps) => {
  const GetUrlForSubmission = (
    profileNumber: string,
    licenceId: string,
    submissionId: string
  ) => {
    return `/licence-profile/${profileNumber}/versions/${licenceId}/submissions/${submissionId}`;
  };

  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetSubmissionsByLicenceFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(licenceId);

  const tableColumnsBig: Column<Record<string, ISubmissionRow>>[] = [
    {
      Header: "Case No.",
      accessor: "casenumber",
      Filter: false,
      filter: "casenumber",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td>
              <Link
                to={GetUrlForSubmission(
                  licenceProfile.profileNo,
                  rowInfo.row.original.licenceid,
                  rowInfo.row.original.submissionid
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Submitter / Objector",
      accessor: "submitter",
      Filter: false,
      filter: "includes",
    },
    {
      Header: "Type",
      accessor: "type",
      Filter: CreateStaticSelectColumnFilter(
        submissionTypes.list.map((option) => option.value)
      ),
    },
    {
      Header: "Objector Type",
      accessor: "objectortype",
      Filter: CreateStaticSelectColumnFilter(
        submissionObjectorTypes.list.map((option) => option.value)
      ),
    },
    {
      Header: "Received Date",
      accessor: "receiveddate",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
  ];

  const tableColumnsSmall: Column<Record<string, ISubmissionRow>>[] = [
    {
      Header: "Case No.",
      accessor: "casenumber",
      Filter: false,
      filter: "casenumber",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td>
              <Link
                to={GetUrlForSubmission(
                  licenceProfile.profileNo,
                  rowInfo.row.original.licenceid,
                  rowInfo.row.original.submissionid
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Type",
      accessor: "type",
      Filter: CreateStaticSelectColumnFilter(
        submissionTypes.list.map((option) => option.value)
      ),
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { SubmissionsGrid };
